var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 74.9997L0 56.2497H18.4267L0 37.823H37.1767V74.9997L18.75 56.5732V74.9997Z",
    fill: "url(#paint0_linear_22_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 74.9998L0 -0.000244141H75V74.9998Z",
    fill: "url(#paint1_linear_22_259)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_259",
    x1: 75,
    y1: 33.6204,
    x2: 9.375,
    y2: 33.6204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4DBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#8596D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1A6CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_259",
    x1: 75,
    y1: 33.6205,
    x2: 9.375,
    y2: 33.6205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4DBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#8596D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1A6CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0 -0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider10);
export default __webpack_public_path__ + "static/media/slider-10.d4885529f482a520c2f9db1c656d3548.svg";
export { ForwardRef as ReactComponent };